<shrd-uic-modal
  #outdatedVersionOverlay
  size="sm"
  [title]="'shared.modals.outdatedVersionOverlay.title' | i18next"
  [closeText]="'shared.buttons.close' | i18next"
  [bodyRef]="outdatedVersionBody"
  [footerRef]="outdatedVersionFooter"
>
  <ng-template #outdatedVersionBody>
    <div class="container-fluid bg-white mt-2">
      <div class="row">
        <div class="col-24">
          <div class="content-box">
            <p>
              <span>
                <strong>{{ 'shared.modals.outdatedVersionOverlay.primaryText' | i18next }}</strong>
              </span>
              <br />
              {{ 'shared.modals.outdatedVersionOverlay.secondaryText' | i18next }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #outdatedVersionFooter>
    <shrd-uic-smartbar [isFixed]="false">
      <div class="smartbar-column-right">
        <div class="content-box">
          <button
            
            class="transfer-overlay-button"
            shrdUicButton
            variant="primary"
            (click)="refreshPage()"
          >
            <span>{{ 'shared.buttons.refreshPage' | i18next }}</span>
          </button>
        </div>
      </div>
    </shrd-uic-smartbar>
  </ng-template>
</shrd-uic-modal>
